import React from "react";

// Theme types
export interface ThemeColors {
  bg: string;
  surface: string;
  ink: string;
  accent: string;
  accentDark: string;
  muted: string;
  cardShadow: string;
}

export interface ThemeFonts {
  brand: string;
  menu: string;
  body: string;
}

export interface Theme {
  colors: ThemeColors;
  fonts: ThemeFonts;
}

export const theme: Theme = {
  colors: {
    bg: "#fbf5ef",
    surface: "#fff8f1",
    ink: "#1c120b",
    accent: "#74421d",
    accentDark: "#5b3418",
    muted: "#6f5d52",
    cardShadow: "0 12px 40px rgba(28,18,11,.08)",
  },
  fonts: {
    brand: '"Noto Serif Hebrew", ui-serif, Georgia, serif',
    menu: '"Heebo", ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif',
    body: '"Heebo", ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif',
  },
};

export interface SectionProps {
  id: string;
  className?: string;
  children?: React.ReactNode;
}

export const Section: React.FC<SectionProps> = ({ id, className = "", children }) => (
  <section id={id} className={`scroll-mt-24 ${className}`}>{children}</section>
);

export interface ContainerProps {
  className?: string;
  children?: React.ReactNode;
}

export const Container: React.FC<ContainerProps> = ({ className = "", children }) => (
  <div className={`w-full px-4 ${className}`}>{children}</div>
);


